/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coins_Pack_PouchInputs */

const en_coins_pack_pouch = /** @type {(inputs: Coins_Pack_PouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bag of Coins`)
};

const ar_coins_pack_pouch = /** @type {(inputs: Coins_Pack_PouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كيس من العملات`)
};

const de_coins_pack_pouch = /** @type {(inputs: Coins_Pack_PouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Beutel Münzen`)
};

const es_coins_pack_pouch = /** @type {(inputs: Coins_Pack_PouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bolsa de monedas`)
};

const fr_coins_pack_pouch = /** @type {(inputs: Coins_Pack_PouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un sac de Pièces`)
};

const it_coins_pack_pouch = /** @type {(inputs: Coins_Pack_PouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Borsa di Monete`)
};

const ja_coins_pack_pouch = /** @type {(inputs: Coins_Pack_PouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`袋一杯のコイン`)
};

const ko_coins_pack_pouch = /** @type {(inputs: Coins_Pack_PouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`코인 한 자루`)
};

const pt_br_coins_pack_pouch = /** @type {(inputs: Coins_Pack_PouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saco de moedas`)
};

const ru_coins_pack_pouch = /** @type {(inputs: Coins_Pack_PouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сумка монет`)
};

const th_coins_pack_pouch = /** @type {(inputs: Coins_Pack_PouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เหรียญหนึ่งถุง`)
};

const tr_coins_pack_pouch = /** @type {(inputs: Coins_Pack_PouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bir Çuval Jeton`)
};

const zh_cn_coins_pack_pouch = /** @type {(inputs: Coins_Pack_PouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一袋金币`)
};

const zh_tw_coins_pack_pouch = /** @type {(inputs: Coins_Pack_PouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一袋金幣`)
};

/**
* | output |
* | --- |
* | "Bag of Coins" |
*
* @param {Coins_Pack_PouchInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const coins_pack_pouch = /** @type {((inputs?: Coins_Pack_PouchInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coins_Pack_PouchInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coins_pack_pouch(inputs)
	if (locale === "ar") return ar_coins_pack_pouch(inputs)
	if (locale === "de") return de_coins_pack_pouch(inputs)
	if (locale === "es") return es_coins_pack_pouch(inputs)
	if (locale === "fr") return fr_coins_pack_pouch(inputs)
	if (locale === "it") return it_coins_pack_pouch(inputs)
	if (locale === "ja") return ja_coins_pack_pouch(inputs)
	if (locale === "ko") return ko_coins_pack_pouch(inputs)
	if (locale === "pt_br") return pt_br_coins_pack_pouch(inputs)
	if (locale === "ru") return ru_coins_pack_pouch(inputs)
	if (locale === "th") return th_coins_pack_pouch(inputs)
	if (locale === "tr") return tr_coins_pack_pouch(inputs)
	if (locale === "zh_cn") return zh_cn_coins_pack_pouch(inputs)
	return zh_tw_coins_pack_pouch(inputs)
});